export default __webpack_public_path__ + "static/media/logo-horizontal.717d9508.svg";